import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { useProduct } from "../../store/product";
import { styled } from "@mui/material";

export const StyledCroppedCanvas = styled('div')`
  width: 100%;
  min-height: 200px;
  background-size: contain;
  background-position: center;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
`;

const CroppedCanvas = () => {
  const product = useProduct(s => s.product);
  const image = useCropperStore(s => s.getCropper()).getCroppedCanvas().toDataURL("image/png");
  return <StyledCroppedCanvas src={image} alt={product.name} />
}

export default CroppedCanvas;